// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import BarLineChartSvg from '@rsuite/icon-font/lib/charts/BarLineChart';
var BarLineChart = createSvgIcon({
  as: BarLineChartSvg,
  ariaLabel: 'bar line chart',
  category: 'charts',
  displayName: 'BarLineChart'
});
export default BarLineChart;